/*import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify, {
  iconfont: 'md',
  customProperties: true,
  theme: {
    secondary: colors.grey
  }
})*/

import Vue from 'vue'
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md' || 'mdi',
  },
  light: true,
  themes: {
    light: {
      secondary: colors.grey
    }
  }
})